import Development from './development'
import Production from './production'

declare let NODE_ENV: string

export default NODE_ENV === 'development' ? Development : Production
